import type { FunctionComponent } from "react";

import { Container, Title } from "./styles";
import { TrendingTopicsList } from "./trending-topics-list";
export type Props = {
  className?: string;
};

export const TrendingTopics: FunctionComponent<Props> = ({ className }) => (
  <Container className={className}>
    <Title>Trending Topics</Title>
    <TrendingTopicsList />
  </Container>
);

TrendingTopics.displayName = "TrendingTopics";
